import type React from 'react';

import {
  EndIcon,
  GeofenceEventInIcon,
  GeofenceEventOutIcon,
  PathTaken,
  PlannedRoute,
  PluggedIcon,
  SpeedEventIcon,
  StartIcon,
  StopInNotRegisteredPlaceIcon,
  StopInRegisteredPlaceIcon,
  StopWithIdleOnIcon,
  UnpluggedIcon,
  VideoCamIcon,
} from './icons';

export interface LegendItem {
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
  description: string;
}

export const baseLegendItems: LegendItem[] = [
  { Icon: StartIcon, description: 'Início do trajeto' },
  { Icon: EndIcon, description: 'Fim do trajeto' },
  { Icon: PathTaken, description: 'Trajeto realizado' },
  { Icon: PlannedRoute, description: 'Rota planejada' },
  { Icon: SpeedEventIcon, description: 'Velocidade excedida' },
  { Icon: UnpluggedIcon, description: 'Dispositivo desconectado' },
  { Icon: PluggedIcon, description: 'Dispositivo conectado' },
  { Icon: GeofenceEventInIcon, description: 'Entrada em local de interesse' },
  { Icon: GeofenceEventOutIcon, description: 'Saída de local de interesse' },
  { Icon: StopWithIdleOnIcon, description: 'Parada com motor ocioso' },
];

export const itemsWhenAllowedToViewPlacesOfInterest: LegendItem[] = [
  {
    Icon: StopInRegisteredPlaceIcon,
    description: 'Parada em local cadastrado',
  },
  {
    Icon: StopInNotRegisteredPlaceIcon,
    description: 'Parada fora de local cadastrado',
  },
];

export const itemsWhenNotAllowedToViewPlacesOfInterest: LegendItem[] = [
  {
    Icon: StopInNotRegisteredPlaceIcon,
    description: 'Parada',
  },
];

export const mediaEventItems: LegendItem[] = [{ Icon: VideoCamIcon, description: 'Evento com vídeo' }];
